import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { createSetter } from 'shared/redux-helpers'

const initialState = {
	campaigns: [] as { id: string }[],
	campaignsCount: null,
	filters: {
		active: false,
		cancelled: false,
		completed: false,
		drafted: false,
		stopped: false
	},
	haveCampaigns: false,
	loadCampaignsController: false,
	scrollToAction: false,
	searchArchiveValue: '',
	searchValue: ''
}

type Slice = typeof initialState

const isFilterActive = (state: Slice) =>
	Object.values(state.filters).some(filter => filter === true)

const campaignsSlice = createSlice({
	initialState,
	name: 'campaigns',
	reducers: {
		setArchive: createSetter<Slice>('searchArchiveValue'),
		setCampaigns(
			state,
			{ payload }: PayloadAction<Pick<Slice, 'campaigns' | 'campaignsCount'>>
		) {
			state.campaigns = payload.campaigns
			state.campaignsCount = payload.campaignsCount
		},
		setFilters: createSetter<Slice>('filters'),
		setHaveCampaigns: createSetter<Slice>('haveCampaigns'),
		setLoadCampaigns: createSetter<Slice>('loadCampaignsController'),

		setScrollToAction: createSetter<Slice>('scrollToAction'),
		setSearch: createSetter<Slice>('searchValue'),

		toggleFilter(state, { payload }: PayloadAction<keyof Slice['filters']>) {
			state.filters[payload] = !state.filters[payload]
		},
		updateOne(state, action: PayloadAction<Slice['campaigns'][number]>) {
			const update = action.payload
			const index = state.campaigns.findIndex(item => item.id === update.id)

			if (index > -1) {
				state.campaigns[index] = update
			}
		}
	},
	selectors: {
		filterQuery: ({ filters }) => {
			const filtersArray = []

			if (filters.active) {
				filtersArray.push(`(state eq 'Running')`)
			}
			if (filters.stopped) {
				filtersArray.push(`(state eq 'Stopped')`)
			}
			if (filters.completed) {
				filtersArray.push(`(state eq 'Completed')`)
			}
			if (filters.drafted) {
				filtersArray.push(`(state eq 'Compose')`)
			}

			return filtersArray.join(' or ')
		},

		filters: state => state.filters,
		isFilterActive,
		isFilterOrSearchActive: state =>
			Boolean(state.searchValue) || isFilterActive(state),
		search: state => state.searchValue
	}
})

const campaignsActions = campaignsSlice.actions
const campaignsSelectors = campaignsSlice.selectors

export { campaignsActions, campaignsSelectors, campaignsSlice }
